module.exports = __webpack_public_path__ + "static/media/More-Options.80d0a695.svg";